export const LX_CONFIG = {
    COMP_MV_BID: 'b_daodian_lowcode_oixoku5x_mv',
    CARD_MV_BID: 'b_daodian_lowcode_xm3r0c5z_mv',
    CARD_MC_BID: 'b_daodian_lowcode_lg8f7hk7_mc'
};
